<template>
  <van-radio-group class="radio-group" v-model="value">
    <van-cell-group>
      <cell-radio
        v-for="item in options"
        :key="item.value"
        :title="item.label"
        :value="item.value"
        :activeValue="value"
        @updateValue="updateValue"
      ></cell-radio>
    </van-cell-group>
  </van-radio-group>
</template>

<script>
import CellRadio from './CellRadio.vue';

export default {
  name: 'CellRadioGroup',
  emits: ['update:value'],
  props: {
    value: {
      type: String,
      require: true
    },
    options: {
      type: Array,
      default: [
        {
          label: '',
          value: ''
        }
      ]
    }
  },
  methods: {
    updateValue(value) {
      this.$emit('update:value', value);
    }
  },
  components: {
    CellRadio
  }
};
</script>

<style lang="scss" scoped>
.radio-group {
  overflow: hidden;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);
}
</style>
